export default __webpack_public_path__ + "static/media/hero44.02e760d8.jpg";